const DETAIL_PLANNING_NUMERIQUE = {
  title: 'Planning {typeProduit}',
  produit: {
    reseauNum: 'réseau numérique',
    ecranNum: 'écran numérique',
  },
  racine: 'Accueil',
  actions: {
    filtre: 'Filtre',
  },
  tab: {
    libelle: 'Libellé',
    audience: 'Audience / an',
    enseignePrincipale: 'Enseigne principale',
    societe: 'Société',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    libelle: 'Libellé',
    enseignePrincipale: 'Enseigne principale',
    enseigneMarque: 'Enseignes / Marques',
    ville: 'Ville',
    nombreHabitant: 'Nombre d’habitants',
    societe: 'Société',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  panier: {
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
  },
};

export default DETAIL_PLANNING_NUMERIQUE;
